import { render, staticRenderFns } from "./Dialog_ChooseClassPackageDetail.vue?vue&type=template&id=3497e9a0&scoped=true&"
import script from "./Dialog_ChooseClassPackageDetail.vue?vue&type=script&lang=js&"
export * from "./Dialog_ChooseClassPackageDetail.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_ChooseClassPackageDetail.vue?vue&type=style&index=0&id=3497e9a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3497e9a0",
  null
  
)

export default component.exports